export default __webpack_public_path__ + "img/67c461a41024b1938fb4c18671dfd592.png";